import React from "react";
import InputLayout2 from "./InputLayout2";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import ErrorLabel from "./ErrorLabel";
import { Controller } from "react-hook-form";
import { InputOtp } from "primereact/inputotp";
import { capitalizeCamelCase } from "utils/common";
import { InputTextarea } from "primereact/inputtextarea";
import InputLayout from "./InputLayout";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Calendar } from "primereact/calendar";
import { NumericFormat } from "react-number-format";
import dollarIcon from "assets/icons/dollar.svg";
import { number } from "utils/regex";
import { on } from "events";
import currencyCodes from "currency-codes";
import getSymbolFromCurrency from "currency-symbol-map";

export const CustomInput = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  isSearch,
  tooltipContent,
  note,
  ignoreError,
  searchIcon,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
      tooltipContent={tooltipContent}
      note={note}
      ignoreError={ignoreError}
    >
      <div className="input-box">
        <InputText
          id={name}
          name={name}
          value={value || (data ? data[name] : "")}
          type={type}
          onChange={(e) =>
            onChange &&
            onChange({ ...e, name: e.target.name, value: e.target.value })
          }
          className={`input-bg w-full mb-1 ${inputClass ? inputClass : ""} ${
            errorMessage ? "p-invalid" : ""
          }`}
          placeholder={
            placeholder || `Enter ${name ? capitalizeCamelCase(name) : ""}`
          }
          disabled={disabled}
          {...props}
        />
        {isSearch ? (
          <i className="pi pi-spin pi-spinner" />
        ) : searchIcon ? (
          <i className="pi pi pi-search font-bold text-lg color-verdigris" />
        ) : null}
        {spanLabel && <span className="p-inputgroup-addon">{spanLabel}</span>}
      </div>
    </InputLayout>
  );
};

export const CustomTextInput = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  required,
  col = 6,
  errorMessage,
  extraClassName,
  inputClass,
  disabled = false,
  ignoreLabel = false,
  data = {},
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      data={data}
      errorMessage={errorMessage}
      extraClassName={extraClassName}
      ignoreLabel={ignoreLabel}
    >
      <input
        type="text"
        name={name}
        value={value || data?.[name] || ""}
        onChange={(e) => onChange && onChange({ name, value: e.target.value })}
        placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
        className={`input-bg input border-1 text-base p-inputtext w-full ${
          inputClass ? inputClass : ""
        } ${errorMessage ? "p-invalid" : ""}`}
        disabled={disabled}
      />
    </InputLayout>
  );
};


export default function CustomInput2({
  value,
  onChange,
  extraClass,
  extraClassName,
  label,
  control,
  name,
  data,
  placeHolder,
  type = "text",
  disabled,
  isSearch,
  spanLabel,
  ignoreLabel,
  ...props
}) {
  if (control) {
    return (
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange, onBlur, value },
          fieldState: { error },
        }) => (
          <>
            <InputLayout2
              extraClass={extraClass}
              name={name}
              label={label}
              ignoreLabel={ignoreLabel}
            >
              <InputText
                className="input-bg w-full border-none mt-2 mb-1"
                value={value || ""}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={`Enter ${capitalizeCamelCase(name)}`}
              />
              {error && <ErrorLabel>{error.message}</ErrorLabel>}
            </InputLayout2>
          </>
        )}
      />
    );
  }
  return (
    <InputLayout2
      extraClassName={extraClassName}
      name={name}
      label={label}
      data={data}
      ignoreLabel={ignoreLabel}
    >
      <InputText
        id={name}
        name={name}
        value={value || data?.[name] || ""}
        type={type}
        onChange={(e) =>
          onChange &&
          onChange({ ...e, name: e.target.name, value: e.target.value })
        }
        className="input-bg w-full border-none mt-2 mb-1"
        placeholder={placeHolder || `Enter ${capitalizeCamelCase(name)}`}
        disabled={disabled}
        {...props}
      />
      {isSearch && <i className="pi pi-spin pi-spinner" />}
      {spanLabel && <span className="p-inputgroup-addon">{spanLabel}</span>}
    </InputLayout2>
  );
}

export const CustomInputOtp2 = ({
  value,
  onChange,
  extraClass,
  label,
  control,
  name,
}) => {
  if (control) {
    return (
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange, onBlur, value },
          fieldState: { error },
        }) => (
          <>
            <InputLayout2 extraClass={extraClass} label={label}>
              <InputOtp
                className="mercury-bg w-full border-none mt-2 mb-1"
                value={value}
                onChange={(e) => onChange(e.value)}
                onBlur={onBlur}
                integerOnly
                length={6}
              />
              {error && <ErrorLabel>{error.message}</ErrorLabel>}
            </InputLayout2>
          </>
        )}
      />
    );
  }
  return (
    <InputLayout2 extraClass={extraClass} label={label}>
      <InputOtp
        className="mercury-bg w-full border-none mt-2 mb-1"
        value={value}
        onChange={onChange}
        integerOnly
      />
    </InputLayout2>
  );
};

export const CustomInputOtp = ({
  value,
  data,
  name,
  onChange,
  extraClass,
  label,
}) => {
  return (
    <>
      <InputLayout extraClass={extraClass} name={name}>
        <InputOtp
          className="mercury-bg w-full border-none mt-2 mb-1"
          value={value || data[name] || ""}
          onChange={(e) =>
            onChange && onChange({ ...e, name: name, value: e.value })
          }
          integerOnly
          length={6}
        />
      </InputLayout>
    </>
  );
};

export const CustomTextArea = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  isSearch,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <div className="input-box ">
        <InputTextarea
          id={name}
          name={name}
          value={value || data?.[name] || ""}
          type={type}
          rows={5}
          cols={30}
          onChange={(e) =>
            onChange &&
            onChange({ ...e, name: e.target.name, value: e.target.value })
          }
          className={`input-bg w-full ${inputClass ? inputClass : ""} ${
            errorMessage ? "p-invalid" : ""
          }`}
          placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
          disabled={disabled}
          {...props}
        />
        {isSearch && <i className="pi pi-spin pi-spinner" />}
        {spanLabel && <span className="p-inputgroup-addon">{spanLabel}</span>}
      </div>
    </InputLayout>
  );
};

export const CustomFileInput = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "file",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  isSearch,
  tooltipContent,
  note,
  ignoreError,
  accept,
  isMulitple,
  selectedFiles,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
      tooltipContent={tooltipContent}
      note={note}
      ignoreError={ignoreError}
    >
      <div className="input-box">
        <input
          id={name}
          name={name}
          type={"file"}
          accept={accept || ".jpg,.jpeg,.png,.pdf"} //.doc,.xls,.zip .pdf
          onChange={onChange}
          // onClick={(event) => {
          //   if (
          //     event.target.files.length === 1 &&
          //     event.target.files[0].name ===
          //     selectedFiles[selectedFiles.length - 1]?.name
          //   ) {
          //     event.target.value = null;
          //   }
          // }}
          className={`input-bg w-full mb-1 ${inputClass ? inputClass : ""} ${
            errorMessage ? "p-invalid" : ""
          }`}
          placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
          disabled={disabled}
          multiple={isMulitple}
          {...props}
        />
        {isSearch && <i className="pi pi-spin pi-spinner" />}
        {spanLabel && <span className="p-inputgroup-addon">{spanLabel}</span>}
      </div>
    </InputLayout>
  );
};

export const CustomDropDown = ({
  label,
  name,
  onChange,
  data,
  value,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  optionLabel = "name",
  placeholder = "",
  multiple,
  ignoreLabel,
  colors,
  options,
  inputClass,
  ...props
}) => {
  const selectedValueTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>{option?.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const OptionsTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <div>{option[optionLabel]}</div>
      </div>
    );
  };

  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <Dropdown
        id={name}
        name={name}
        value={value || data?.[name]}
        onChange={(e) =>
          onChange && onChange({ ...e, name: e.target.name, value: e.value })
        }
        className={`input-bg w-full custom-dropdown mb-1 ${
          errorMessage ? "p-invalid" : ""
        } ${inputClass}`}
        optionLabel={optionLabel || "name"}
        placeholder={
          placeholder || `Select ${name ? capitalizeCamelCase(name) : ""}`
        }
        valueTemplate={selectedValueTemplate}
        itemTemplate={OptionsTemplate}
        options={options.map((option) => ({
          ...option,
          disabled: option.disabled || false, // Disable conditionally
        }))}
        {...props}
        // filter
      />
    </InputLayout>
  );
};

export const CustomPassword = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 12,
  inputClass,
  disabled = false,
  placeholder = "",
  ignoreError,
  ignoreLabel,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
      ignoreError={ignoreError}
    >
      <Password
        name={name}
        className="w-full mt-1 block "
        inputClassName="mercury-bg w-full border-none mt-1 mb-1"
        value={value || data?.[name] || ""}
        onChange={(e) => {
          onChange &&
            onChange({ ...e, name: e.target.name, value: e.target.value });
        }}
        placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
        toggleMask
        {...props}
      />
    </InputLayout>
  );
};

export const CustomCheckbox = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col,
  inputClass,
  template,
  checked,
  ...props
}) => {
  return (
    <InputLayout
      col={col || 6}
      name=""
      extraClassName={extraClassName}
      errorMessage={data?.formErrors?.[name]}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) =>
          onChange &&
          onChange({ ...e, name: e.target.name, value: e.target.checked })
        }
        id={name}
        className=""
        name={name}
        inputId={label}
      />
      {/* <Checkbox
        type="checkbox"
        id={name}
        name={name}
        inputId={label}
        checked={value || data?.[name]}
        onChange={(e) =>
          onChange && onChange({ ...e, name: e.target.name, value: e.checked })
        }
        className={`input-bg checkbox ${inputClass ? inputClass : ""} ${errorMessage ? "p-invalid" : ""
          }`}
        {...props}
      /> */}
      {label && (
        <label htmlFor={name} className="line-height-3 ml-1 cursor-pointer">
          {label}
        </label>
      )}
      {template && <>{template}</>}
    </InputLayout>
  );
};

export const CustomIconField = ({
  label,
  name,
  data,
  value,
  onChange,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  isSearch,
  tooltipContent,
  note,
  ignoreError,
  icon = "pi pi-times",
  onClick,
  iconPosition = "right",
  errorMessage,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
      tooltipContent={tooltipContent}
      note={note}
      ignoreError={ignoreError}
    >
      <div className="input-box">
        <IconField iconPosition={iconPosition}>
          <InputIcon
            className={`${icon} cursor-pointer`}
            onClick={() => onClick && onClick()}
          >
            {" "}
          </InputIcon>
          <InputText
            id={name}
            name={name}
            value={value || data?.[name] || ""}
            type={type}
            onChange={(e) =>
              onChange &&
              onChange({ ...e, name: e.target.name, value: e.target.value })
            }
            className={`input-bg w-full mb-1 ${inputClass ? inputClass : ""} ${
              errorMessage ? "p-invalid" : ""
            }`}
            placeholder={
              placeholder || `Enter ${name ? capitalizeCamelCase(name) : ""}`
            }
            disabled={disabled}
            {...props}
          />
        </IconField>
      </div>
    </InputLayout>
  );
};

export const CustomCalendar = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  isSearch,
  tooltipContent,
  note,
  ignoreError,
  searchIcon,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
      tooltipContent={tooltipContent}
      note={note}
      ignoreError={ignoreError}
    >
      <div className="input-box">
        <Calendar
          id={name}
          name={name}
          value={value || (data ? data[name] : "")}
          type={type}
          onChange={(e) =>
            onChange &&
            onChange({ ...e, name: e.target.name, value: e.target.value })
          }
          className={`input-bg w-full mb-1 ${inputClass ? inputClass : ""} ${
            errorMessage ? "p-invalid" : ""
          }`}
          placeholder={
            placeholder || `Enter ${name ? capitalizeCamelCase(name) : ""}`
          }
          disabled={disabled}
          {...props}
          showIcon
        />
        {isSearch ? (
          <i className="pi pi-spin pi-spinner" />
        ) : searchIcon ? (
          <i className="pi pi pi-search font-bold text-lg color-verdigris" />
        ) : null}
        {spanLabel && <span className="p-inputgroup-addon">{spanLabel}</span>}
      </div>
    </InputLayout>
  );
};

export const CustomAmountInput = ({
  label,
  name,
  data,
  options,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  spanExtraClassName,
  spanIcon,
  ignoreIcon,
  optionLabel = "name",
  showDropdown = false,
  inputplaceholder,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <div className={`p-inputgroup flex w-full `}>
        <NumericFormat
          value={value || data?.[name]}
          thousandSeparator=","
          decimalSeparator="."
          decimalScale={2}
          fixedDecimalScale={true}
          allowNegative={false}
          onValueChange={(e) => {
            onChange && onChange({ ...e, name: name, value: e.value });
          }}
          // prefix="$"
          className={`input border-1 text-base p-inputtext numeric_input w-full  ${
            inputClass ? inputClass : ""
          } ${errorMessage ? "p-invalid" : ""}`}
          placeholder={inputplaceholder || `Enter ${capitalizeCamelCase(name)}`}
          disabled={disabled}
        />
        {spanLabel && (
          <span
            className={`p-inputgroup-addon p-0 ${
              spanExtraClassName ? spanExtraClassName : ""
            }`}
          >
            {spanLabel}
          </span>
        )}

        {!ignoreIcon && showDropdown && (
          <span
            className={`p-inputgroup-addon p-0 ${spanExtraClassName || ""}`}
          >
            {spanIcon ? (
              <img src={spanIcon} />
            ) : (
              <Dropdown
                className="border-none bg-transparent"
                id={name}
                value={value}
                onChange={onChange}
                options={options}
                optionLabel={optionLabel}
                placeholder={placeholder || `Select ${name}`}
              />
            )}
          </span>
        )}
      </div>
    </InputLayout>
  );
};

export const CustomNumberInput = ({
  label,
  name,
  data,
  value,
  onChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  type = "text",
  placeholder = "",
  spanLabel,
  ignoreLabel,
  spanExtraClassName,
  max,
  ...props
}) => {
  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <div className="p-inputgroup flex">
        <InputText
          id={name}
          name={name}
          value={value || data?.[name] || ""}
          type={type}
          onChange={(e) => {
            if (onChange) {
              if (number(e.target.value)) {
                onChange({ ...e, name: e.target.name, value: e.target.value });
              } else if (!e.target.value) {
                onChange({ ...e, name: e.target.name, value: e.target.value });
              }
            }
          }}
          className={`input w-full mb-1 ${inputClass ? inputClass : ""} ${
            errorMessage ? "p-invalid" : ""
          }`}
          placeholder={placeholder || `Enter ${capitalizeCamelCase(name)}`}
          disabled={disabled}
          maxLength={max}
          {...props}
        />
        {spanLabel && (
          <span
            className={`p-inputgroup-addon ${
              spanExtraClassName ? spanExtraClassName : ""
            }`}
          >
            {spanLabel}
          </span>
        )}
      </div>
    </InputLayout>
  );
};

export const CustomAmountDropdown = ({
  label,
  name,
  data,
  options = [],
  value,
  onChange,
  onCurrencyChange,
  errorMessage,
  extraClassName,
  required,
  col = 6,
  inputClass,
  disabled = false,
  placeholder = "",
  spanLabel,
  ignoreLabel,
  spanExtraClassName,
  spanIcon,
  ignoreIcon,
  optionLabel = "name",
  showDropdown = true,
  inputplaceholder,
  currencyCode = "",
  enableCurrencySelect = true,
  showPercentageSymbol = false, // New prop to control %
  ...props
}) => {
  // Get all currencies and format for dropdown
  const allCurrencies = currencyCodes.codes().map((code) => {
    return {
      code,
      symbol: getSymbolFromCurrency(code) || code,
    };
  });

  // Find current currency based on currencyCode prop
  const currentCurrency = allCurrencies.find((c) => c.code === currencyCode) || {
    code: "USD",
    symbol: "$",
  };

  const handleCurrencyChange = (e) => {
    if (onCurrencyChange && e.value) {
      onCurrencyChange(e.value); // Pass the symbol to parent
    }
  };

  return (
    <InputLayout
      col={col}
      label={label}
      name={name}
      required={required}
      extraClassName={extraClassName}
      data={data}
      errorMessage={errorMessage}
      ignoreLabel={ignoreLabel}
    >
      <div className={`p-inputgroup flex w-full`}>
        {/* Amount input */}
        <NumericFormat
          value={value || data?.[name]}
          thousandSeparator=","
          decimalSeparator="."
          fixedDecimalScale={true}
          allowNegative={false}
          onValueChange={(e) => {
            onChange && onChange({ ...e, name: name, value: e.value });
          }}
          className={`input-share-btn border-1 text-base p-inputtext numeric_input w-full ${
            inputClass ? inputClass : ""
          } ${errorMessage ? "p-invalid" : ""}`}
          placeholder={inputplaceholder || `Enter ${capitalizeCamelCase(name)}`}
          disabled={disabled}
        />

        {/* Show % symbol or currency selector */}
        {showPercentageSymbol ? (
          <span className="p-inputgroup-addon bg-gray-100 text-black px-3 border border-l-0 ">
            %
          </span>
        ) : (
          enableCurrencySelect && (
            <span className={`p-inputgroup-addon p-0 ${spanExtraClassName || ""}`}>
              <Dropdown
                value={data.currencySymbol}
                onChange={handleCurrencyChange}
                options={allCurrencies}
                optionLabel="symbol"
                itemTemplate={(option) => (
                  <div className="flex items-center">
                    <span className="mr-2">{option.symbol}</span>
                    <span className="text-gray-500 text-sm">{option.code}</span>
                  </div>
                )}
                valueTemplate={(option) =>
                  option ? (
                    <div className="flex items-center">
                      <span>{option.symbol}</span>
                    </div>
                  ) : (
                    "Select currency"
                  )
                }
              />
            </span>
          )
        )}
      </div>
    </InputLayout>
  );
};
